import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'quantityCheck'
})
export class QuantityCheckPipe implements PipeTransform {

  transform(value: number, market_id: string, market_lot): any {
    if (value && !isNaN(value) && market_id && market_lot && (market_id.endsWith('CDS') || market_id === 'MSECD')) {
        return +value / +market_lot;
    }
    return value;
}

}
